export enum AuthEnum {
	TOKEN_KEY = '@HSGJ%$DF$#DDSH6',
	USER_KEY = '@HappyCode/login',
}
